import { useCallback, useEffect, useRef, useState } from 'react';
import { forexApi, managedMaintenanceError, type ProvisioningJob } from '@/lib/forex-api';

export function useManagedInstance(jobId: string, initial?: ProvisioningJob) {
  const [job,setJob]=useState<ProvisioningJob | null>(initial || null);
  const [error,setError]=useState('');
  const epoch=useRef(0);
  const currentId=useRef(jobId); currentId.current=jobId;
  const refresh=useCallback(async()=>{
    const request=++epoch.current;
    try {
      const value=await forexApi.getProvisioningJob(jobId);
      if (currentId.current!==jobId || request!==epoch.current) return;
      setJob(previous=>previous?.provision_job_id===value.provision_job_id && (previous.revision || 0)>(value.revision || 0) ? previous : value);
      setError('');
    } catch(e) {if (request===epoch.current) setError(managedMaintenanceError(e));}
  },[jobId]);
  const invalidate=useCallback(()=>{epoch.current++;},[]);
  useEffect(()=>{
    setJob(initial || null);setError('');
    if(!jobId) return;
    void refresh();
    const timer=setInterval(()=>void refresh(),3000);
    return ()=>{invalidate();clearInterval(timer);};
    // Initial value seeds the selected job only; refresh owns live state.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[jobId,refresh,invalidate]);
  return {job,error,refresh};
}
